import { makeAutoObservable } from 'mobx';
import { MobXProviderContext } from 'mobx-react';
import { useContext } from 'react';
export class AppStore {
    todos: string[] = [];
    constructor() {
        makeAutoObservable(this);
    }

    setTodos(todos: string[]) {
        this.todos = todos;
    }
}

export const useAppStore = (): AppStore => {
    const context = useContext(MobXProviderContext);
    return context.store;
};
